import $ from "jquery";
import { logger } from "./logger";

function downloadFile(params) {
    return $.Deferred(function(def) {
        if (!params.url) {
            logger.error(
                "Call made to fileDownloader.downloadFile with no URL to download from");
            def.reject();
        }
        //Create iFrame and set visibility.
        const iFrame = $("<iframe />")
            .attr({
                style: "visibility: hidden;display:none;"
            });
        $("body").append(iFrame);

        //Build iFrame contents parameters.
        buildForm(params, iFrame);
        
        //Submit Form.
        iFrame.contents().find("form").submit();
    });
}

function buildForm(params, iFrame) {
    iFrame.contents().find("body").append(
        "<form novalidate action=\"" + params.url + "\" method=\"" + params.method + "\"></form>");
    const form = iFrame.contents().find("form");
    if (!params.data) return;

    //Loop through all data elements to add them as html inputs into the form.
    for (const key in params.data) {
        if (Array.isArray(params.data[key])) {
            const select = form.append("<select name=\"" + key + "\" multiple>").find("select");
            for (let i = 0; i < params.data[key].length; i++) {
                select.append("<option value=\"" + params.data[key] + "\" selected></option>");
            }
        } else {
            form.append("<input name=\"" + key + "\" value=\"" + params.data[key] + "\"/>");
        }
    }
}

export const fileDownloader = {
    downloadFile: downloadFile
};